import React, {Fragment, useEffect, useState} from "react";

import {
    defaultTableHeaderStyles,
    customHeaderStyle,
    defaultTopRightCellStyle
} from "../../Tables/BaseTableComponents";


import PassportTable, {xlateBootstrapTableColumns} from "../../Tables/PassportTable";
import SpinnerDiv from "../../ui/ReactSpinnerDiv";
import {getNews} from "../../DataFunctions/NewsDataFns";
import {getDataFromResponse} from "../../DataFunctions/BaseDataFns";
import useModalViewNews from "../Modals/ViewNews/useModalViewNews";
import parse from 'date-fns/parse';
import differenceInDays from 'date-fns/differenceInDays';
import startOfToday from 'date-fns/startOfToday';
import IconTooltip from "../../ui/Tooltip/IconTooltip";

const NewsTable = (props) => {

    const [data, setData] = useState({ isLoading: true, data: [] });
    const [renderViewNewsModal, showViewNewsModal] = useModalViewNews((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    });

    const thisPagePaginationOptions = {
        sizePerPage: 3,
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true,
        showTotal: true,
        className: "neil-pager"
    };

    const userInitialState = {
        pageSize: 3,
    }

        useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if(props.school_id !== undefined)
        {
            getNews(props.school_id, (response) =>
            {
                setData({isLoading: false, data: getDataFromResponse(response)});
            });
        }
    };

    const withinLast7Days = (date) =>{
        var today = startOfToday();
        var diff = differenceInDays(today, parse(date, 'yyyy-MM-dd HH:mm:ss', new Date()));
        return diff < 8;
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        date: {width: '5vw'},
        title: {width: '30vw' },
        owner:{width: '20vw' },
        edit: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "10vw"}
    });

    const openNewsModal = (news_id) => {
        showViewNewsModal(news_id);
    };

    const toolRenderer = (cell, row, rowIndex, formatExtraData) => {
        let showNewFlag = withinLast7Days(row.date)

        return (
            <Fragment>
                <div>
                    { showNewFlag && <span><i className={'glyphicon glyphicon-star'} style={{padding:'10px', color:'red'}}/></span>}
                    <IconTooltip onClick={() => openNewsModal (row.id)} placement='top' text="View News Item" style={{marginRight: '10px'}} icon="glyphicon-eye-open" color="#4992C9"/>
                </div>
            </Fragment>
        );
    };

    const getColumns = () => {
        const columns = [
            {
                dataField: 'date_sent',
                text: "Date",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'title',
                text: "Title",
                search: true,
                width: 200,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'owner',
                text: "Sent By",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: "edit",
                text: "New/View",
                align: "right",
                headerStyle: headerStyle,
                formatter: toolRenderer
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns( getColumns()) ;
    const columns = React.useMemo(() => translations, []) ;

    const tableContent = () =>
    {
        return (
            <Fragment>
                <PassportTable data={data.data} isLoading={data.isLoading} columns={columns}
                               pagination={thisPagePaginationOptions} userInitialState={userInitialState}/>

                {renderViewNewsModal(props)}
            </Fragment>
        )
    }

    return data.isLoading === true ? <SpinnerDiv /> : tableContent();
};

export default NewsTable;
